module.exports = __webpack_public_path__ + "static/media/aboutme.4143b29a.JPG";